const dashboardPageMarketOverviewSectionCopy = {
  error: 'An error occurred while trying to load the market overview. If this error continues to occur, please contact our support team.',
  sectionTitle: 'Market Overview'
};

export default dashboardPageMarketOverviewSectionCopy;
